import { useContext, useEffect } from "react";
import { renderTurnstile } from "../api/utils";
import { AuthenticationContext } from "../components/Authentication/Participant/AuthenticationContext";

export function useTurnstile() {
  const { currentLanguage } = useContext(AuthenticationContext);
  useEffect(() => {
    return renderTurnstile(currentLanguage)
  }, [currentLanguage]);
}
